<div
    class="string-match-config"
    provideParentForm
>
    <label
        aviLabelWithTooltip
        objectType="{{ objectType }}"
        fieldName="match_criteria"
        for="match_criteria"
        [required]="areMatchFieldsRequired"
    >
        {{ l10nKeys.criteriaDropdownLabel | vtranslate }}
    </label>
    <avi-enum-dropdown
        id="{{ 'match-criteria-' + id }}"
        name="{{ 'match-criteria-' + id }}"
        [(ngModel)]="editable.config.match_criteria"
        enum="StringOperation"
        [hiddenEnumValues]="hiddenEnumValues"
        [required]="areMatchFieldsRequired"
    ></avi-enum-dropdown>
    <string-group-or-custom-value
        class="string-match-config__string-group-or-custom-value"
        [(stringGroupRefs)]="editable.config.string_group_refs"
        [(customValues)]="editable.config.match_str"
        id="{{ 'string-match-config_' + id }}"
        [noMarginTop]="true"
        [areStringGroupOrCustomFieldsRequired]="areMatchFieldsRequired"
        label="{{ stringGroupOrCustomValueLabel }}"
        [showAddItemButton]="showAddItemButton"
    ></string-group-or-custom-value>
</div>
